import { render, staticRenderFns } from "./billList.vue?vue&type=template&id=641e0cf6&scoped=true&"
import script from "./billList.vue?vue&type=script&lang=js&"
export * from "./billList.vue?vue&type=script&lang=js&"
import style0 from "./billList.vue?vue&type=style&index=0&id=641e0cf6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641e0cf6",
  null
  
)

export default component.exports